import a_Caribbean_heiress from './img/a_Caribbean_heiress.jpg'
import bared_to_you from './img/bared_to_you.jpg'
import call_me from './img/call_me.jpg'
import cruel from './img/cruel.jpg'
import eleanor from './img/eleanor.jpg'
import exposed from './img/exposed.jpg'
import full_exposure from './img/full_exposure.jpg'
import honey_girl from './img/honey_girl.jpg'
import my_personal_bad from './img/my_personal_bad.jpg'
import nora from './img/nora.jpg'
import offer from './img/offer.jpg'
import outlander from './img/outlander.jpg'
import paradise from './img/paradise.jpg'
import pride from './img/pride.jpg'
import red_white from './img/red_white.jpg'
import seven_days from './img/seven_days.jpg'
import the_bugout from './img/the_bugout.jpg'
import the_hating from './img/the_hating.jpg'
import athe_notebook from './img/the_notebook.jpg'
import the_proposal from './img/the_proposal.jpg'
import the_thorn_birds from './img/the_thorn_birds.jpg'
import athe_time from './img/the_time.jpg'
import virgin_river from './img/virgin_river.jpg'
import when_we_Are_birds from './img/when_we_Are_birds.jpg'

export const RBookItems = [
  {
    id:401,
    title:"A Caribbean Heiress in Paris",
    image: a_Caribbean_heiress,
    price:1199,
    
  },
  {
    id:402,
    title:"Bared to You",
    image: bared_to_you,
    price:299,
    
  },
  {
    id:403,
    title:"Call Me By Your Name",
    image: call_me,
    price:299,
    
  },
  {
    id:404,
    title:"Beautifully Cruel",
    image: cruel,
    price:599,
    
  },
  {
    id:405,
    title:"Eleanor & Park",
    image: eleanor,
    price:299,
    
  },
  {
    id:406,
    title:"Exposed",
    image: exposed,
    price:399,
    
  },
  {
    id:407,
    title:"Full Exposure",
    image: full_exposure,
    price:1299,
    
  },
  {
    id:408,
    title:"Honey Girl",
    image: honey_girl,
    price:1799,
    
  },
  {
    id:409,
    title:"My Personal Bad Boy",
    image: my_personal_bad,
    price:899,
    
  },
  {
    id:410,
    title:"Vision in White",
    image: nora,
    price:299,
    
  },
  {
    id:411,
    title:"Bridgerton",
    image:offer,
    price:599,
    
  },
  {
    id:412,
    title:"Outlander",
    image: outlander,
    price:399,
    
  },
  {
    id:413,
    price:499,
    title: "Paradise",
    image: paradise,
    
  },
  {
    id:414,
    price:100,
    title: "Pride and Prejudice",
    image: pride,
   
  },
  {id:415,
    price:1999,
    title: "Red, White & Royal Blue",
    image:  red_white,
    
  },
  {
    id:416,
    price:399,
    title: "Seven Days in June",
    image: seven_days,
    
  },
  {
    id:417,
    price:3399,
    title: "The Dugout",
    image: the_bugout,
    
  },
  {
    id:418,
    price:399,
    title: "The Hating Game",
    image: the_hating,
    
  },
  {
    id:419,
    price:399,
    title: "The Notebook",
    image: athe_notebook,
    
  },
  {
    id:420,
    price:579,
    title: "The Proposal",
    image: the_proposal,
    
  },
  {
    id:421,
    price:499,
    title: "The Thorn Birds",
    image: the_thorn_birds ,
    
  },
  {
    id:422,
    price:1999,
    title: "The Time Traveler's Wife",
    image: athe_time,
    
  },
  {
    id:423,
    price:13999,
    title: "Virgin River",
    image: virgin_river,
    
  },
  {
    id:424,
    price:1399,
    title: "When We Were Birds",
    image: when_we_Are_birds,
    
  },
  
];